import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { PriceListItemProductType } from "@exonn/js-sdk";

export const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.PriceList,
});

export const priceListItemIcons = {
  [PriceListItemProductType.SingleProduct]: "icon-15-single_m",
  [PriceListItemProductType.ParentProduct]: "icon-15-single_parent_m",
  [PriceListItemProductType.Variant]: "icon-15-variant_m",
  [PriceListItemProductType.VariantComponent]: "icon-15-set_part_m",
};

export enum PriceListFormTabs {
  Exceptions = "exceptions",
}
